
import { defineComponent, PropType, toRef } from 'vue';
import { useVModel } from 'vue-composable';
import { Truck } from '@/types/app';
import { useStore } from '@/store';
import { formDefaults } from '@/constants';
import { addOrEditHeader, useAddEditFormState } from '@/utils';
import AppModal from '@/components/modal/base/AppModal.vue';
import TextInput from '@/components/form-controls/base/TextInput.vue';
import NumberInput from '@/components/form-controls/base/NumberInput.vue';

export default defineComponent({
  name: 'TruckAddEditFormModal',
  emits: ['update:openState'],
  components: {
    AppModal,
    TextInput,
    NumberInput
  },
  props: {
    openState: {
      type: Boolean,
      required: true
    },
    truck: {
      type: Object as PropType<Truck>
    }
  },
  setup(props) {
    const isOpen = useVModel(props, 'openState');
    const header = addOrEditHeader(toRef(props, 'truck'));

    const store = useStore();
    const truckState = useAddEditFormState(
      toRef(props, 'truck'),
      formDefaults.truck,
      store.dispatch.trucks.update,
      store.dispatch.trucks.create
    );

    return {
      isOpen,
      header,
      truckState
    };
  }
});
